import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const UplineContactModalStyle = {
  wrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    min-height: 150px;
    flex-direction: column;

    ${media.md} {
      padding: 20px 10px;
    }

    .wrap-inner {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
      max-width: 500px;
    }

    .contact-item {
      display: flex;
      gap: 8px;
      align-items: center;

      ${media.md} {
        flex-direction: column;
      }
    }

    .contact-label {
      font-size: 16px;
      font-weight: 600;
      min-width: 120px;
      color: #333;
      text-align: center;
    }

    .contact-value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 75%;
      width: 100%;
      ${media.md} {
        max-width: 100%;
      }
    }

    .upline-number {
      font-size: 16px;
      font-weight: 600;
      border: 1px solid #dadada;
      border-radius: 6px;
      padding: 8px 16px;
      background: #f1f1f1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;

      ${media.md} {
        width: 100%;
        font-size: 14px;
        max-width: unset;
      }
    }

    .telegram-link {
      font-size: 16px;
      font-weight: 600;
      color: #0088cc;
      text-decoration: none;
      flex: 1;
      padding: 8px 16px;
      border: 1px solid #dadada;
      border-radius: 6px;
      background: #f1f1f1;
      transition: all 0.3s ease;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      &:hover {
        background: #e1f5fe;
        border-color: #0088cc;
      }

      ${media.md} {
        font-size: 14px;
        width: 100%;
      }
    }

    .btn-copy {
      cursor: pointer;
      background: none;
      border: none;
      outline: none;
      line-height: 1;
      color: #407247;
      padding: 8px;
      transition: transform 0.2s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  `,
};
